import * as React from 'react';

import { SVGProps } from '../../types';

export const IconImageSvg = ({ title, titleId, ...props }: SVGProps) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    focusable="false"
    fill="currentColor"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M20 4a2 2 0 012 2v12a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h16zm0 1.5H4a.5.5 0 00-.492.41L3.5 6v12a.5.5 0 00.41.492L4 18.5h16a.5.5 0 00.492-.41L20.5 18V6a.5.5 0 00-.41-.492L20 5.5zm-3.554 3.397l.084.073 2.5 2.5a.75.75 0 01-.976 1.133l-.084-.073L16 10.561l-4.97 4.97a.75.75 0 01-.976.072l-.084-.073-1.47-1.469-2.47 2.47a.75.75 0 01-.976.072l-.084-.073a.75.75 0 01-.073-.976l.073-.084 3-3a.75.75 0 01.976-.073l.084.073 1.47 1.469 4.97-4.97a.75.75 0 01.976-.072zM7 7a2 2 0 110 4 2 2 0 010-4zm0 1.5a.5.5 0 100 1 .5.5 0 000-1z" />
  </svg>
);
